import { useNavigate } from "react-router-dom";
import { getApiClient, initializeApiClient } from "../apiService";

const UpdateAcknowledgement = async (Acknowledgement) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/Acknowledgement/UpdateAC_Acknowledgement`,
    {
      aC_AcknowledgementId: Acknowledgement.aC_AcknowledgementId,
      acknowledgementStatus: Acknowledgement.acknowledgementStatus,
      aI_ApplicationInformationId: Acknowledgement.aI_ApplicationInformationId,
    }
  );

  return response.data.result;
};

export default UpdateAcknowledgement;
